import { config } from '../../../config';
import { isFeatureEnabled, isMicrosoftClarityIntegrationEnabled } from 'h-commons';

const setAptrinsic = () => {
    try{
        let i = "aptrinsic"; window[i] = window[i] || function () {
            (window[i].q = window[i].q || []).push(arguments) //NOSONAR
          }, window[i].p = config.aptrinsicKey, window[i].c = { "iframeModeEnabled": false }; //NOSONAR
    }catch(e){
        console.log("Error while setting the Aptrinsic object",e);
    }
}

const setIdentify = (userDetails) => {
    try {
        if (window.aptrinsic && isFeatureEnabled(hiver.availableFeatures,'integration-gainsight-tracking')) {
            let userObject = {};
            let accountObject = {};
            userObject.id = userDetails.userId;
            userObject.accountId = userDetails.usergroupId;
            userObject.userCreatedAt = userDetails.user_created_at;
            userObject.role = userDetails.roleName;
            accountObject.id = userDetails.usergroupId;
            accountObject.name = userDetails.domain;
            accountObject.ugCreatedAt = userDetails.ug_created_at;
            accountObject.plan = userDetails.planDetails.name;
            accountObject.accountType = userDetails.ugDetails.state;
            accountObject.smCount = userDetails.sharedMailboxes.used;
            accountObject.slCount = userDetails.sharedLabels.used;
            accountObject.ug_mrr = userDetails.mrr;
            accountObject.ug_arr = userDetails.arr;
            window.aptrinsic("identify", userObject, accountObject);
        }
    } catch(e) {
        console.log("Identify call not sent. ", e);
    }

}

 const sendTrackingEvent = (event, data = {}) => {
    try {
        if(window.aptrinsic && isFeatureEnabled(hiver.availableFeatures,'integration-gainsight-tracking')) {
            data.userid = window.hiver.userid;
            data.usergroupid = Number(window.hiver.usergroupid);
            window.aptrinsic("track",event,data);
        }
    } catch(e) {
        console.log("Tracking call not sent", e);
    }

}
 
const sendGenricTrackingEvent = ( event, data={} ) => {
    try {
        window.aptrinsic && window.aptrinsic("track",event,data);
    } catch(e) {
        console.log("Tracking call not sent", e);
    }
}

const initializeClarityScript = (userDetails) => {
    if (!window.clarity)
        return;

    if (isMicrosoftClarityIntegrationEnabled(hiver.availableFeatures)) {
        window.clarity("consent");
        window.clarity("identify", String(userDetails.userId));
    } else {
        window.clarity('stop');
    }  
}

export {
    setAptrinsic,
    setIdentify,
    sendTrackingEvent,
    sendGenricTrackingEvent,
    initializeClarityScript
}